import React from 'react';
import {useTranslation} from 'react-i18next';
import {s} from '@/app/utils/s';
import Space, {spaceSizes} from '@/app/components/Space';
import AuthTitle from '@/app/features/auth/components/auth_title';
import Button from "@/app/components/button";
import OTPInput from "@/app/components/otp_input";
import styles from "@/app/features/auth/pages/create_pin/styles.module.scss";
import ErrorLine from "@/app/components/error_line/widget";
import useCreatePin, {CreatePinStatus} from "@/app/features/auth/pages/create_pin/slice";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import CustomCssTransition from "@/app/components/custom_css_transition/widget";
import {AuthScreenStatus} from "@/app/features/auth";
import PhoneWidget from "@/app/features/auth/pages/phone";

const CreatePinWidget = () => {
  const {t} = useTranslation();
  const {
    code,
    codeRepeat,
    setCode,
    setCodeRepeat,
    pinStatus,
    continued,
    loading,
    error,
    disabled
  } = useCreatePin();

  return (
    <div className={styles.main} id="main">
      <div className={styles.transitionItems} id="transitionItems">
        <TransitionGroup component={null}>
          <CustomCssTransition inProp={pinStatus === CreatePinStatus.FIRST_STEP}>
            <div className={styles.transitionItem} id="transitionItem">
              <AuthTitle title={t(s.createPin)} subtitle={t(s.comeUpWithAPin)}/>
              <Space h={spaceSizes.s50}/>
              <OTPInput length={4} onChange={setCode}/>
            </div>
          </CustomCssTransition>
          <CustomCssTransition inProp={pinStatus === CreatePinStatus.SECOND_STEP}>
            <div className={styles.transitionItem} id="transitionItem">
              <AuthTitle title={t(s.pinConfirmation)} subtitle={t(s.confirmThePin)}/>
              <Space h={spaceSizes.s50}/>
              <OTPInput length={4} onChange={setCodeRepeat}/>
            </div>
          </CustomCssTransition>
        </TransitionGroup>
      </div>
      <Space h={spaceSizes.s20}/>
      <Button
        isLoading={loading}
        isDisabled={disabled}
        onClick={() => continued()}
      >
        {error === null ? t(s.continue) : t(s.back)}
      </Button>
      <Space h={spaceSizes.s14}/>
      <ErrorLine className={styles.errorLine} error={error}/>
    </div>
  );
};

export default CreatePinWidget;